// 固定路由表：当前项目只保留首页，其他地址统一回到首页。
export const constantRoutes = [
    {
        path: '/',
        name: 'Home',
        redirect: '/helicon',
    },
    // Helicon 官网落地页入口。
    {
        path: '/helicon',
        name: 'HeliconHome',
        component: () => import('@/views/helicon/Home.vue'),
        meta: {
            title: 'Helicon',
        },
    },
    // Helicon 产品详情页入口。
    {
        path: '/product',
        name: 'HeliconProduct',
        component: () => import('@/views/helicon/Product.vue'),
        meta: {
            title: 'Helicon 产品',
        },
    },
    // Helicon 联系我们页入口。
    {
        path: '/contact',
        name: 'HeliconContact',
        component: () => import('@/views/helicon/Contact.vue'),
        meta: {
            title: '联系我们',
        },
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/',
    },
]

export default constantRoutes
